module.exports = __webpack_public_path__ + "static/media/logow.1f5ce36d.webp";